"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightPanel = void 0;
const mithril_1 = __importDefault(require("mithril"));
const announce_show_1 = require("../app/components/announce/announce_show");
const booking_show_1 = require("../app/components/booking/booking_show");
const client_show_1 = require("../app/components/client/client_show");
const commercial_offer_show_1 = require("../app/components/commercial_offer/commercial_offer_show");
const contract_show_1 = require("../app/components/contract/contract_show");
const invoice_show_1 = require("../app/components/invoice/invoice_show");
const auth_1 = require("../utils/auth");
const detail_link_1 = require("./detail_link");
function goBackHistory() {
    history.go(-1);
}
function closePanel() {
    window.location.href = window.location.href.replace(/&name=.+&id=.+&action=.+/, "&");
}
function handleEscape(e) {
    if (exports.RightPanel.opened && (e.key == "Escape" || e.code == "Escape")) {
        closePanel();
        e.stopPropagation();
        e.preventDefault();
    }
}
const renderRightPanel = (opts) => {
    const DETAILS_BOXES = auth_1.Auth.isAdmin() ? {
        "clients#show": [client_show_1.ClientShow, "large"],
        "contracts#show": [contract_show_1.ContractShow, "small"],
        "invoices#show": [invoice_show_1.InvoiceShow, "small"],
        "bookings#show": [booking_show_1.BookingShow, "small"],
        "commercial_offers#show": [commercial_offer_show_1.CommercialOfferShow, "small"],
        "announces#show": [announce_show_1.AnnounceShow, "small"]
    } : {
        "bookings#show": [booking_show_1.BookingShow, "small"],
    };
    opts.key = `${opts.name}#${opts.action}:${opts.id}`;
    let out = DETAILS_BOXES[[opts.name, opts.action].join("#")];
    let klazz = undefined, size = 'small', subcomp = undefined;
    if (out) {
        klazz = out[0];
        size = out[1];
        subcomp = (0, mithril_1.default)(klazz, opts);
    }
    exports.RightPanel.opened = !!out;
    exports.RightPanel.size = size;
    exports.RightPanel.name = opts.name;
    return (0, mithril_1.default)(exports.RightPanel, subcomp);
};
exports.RightPanel = {
    opened: false,
    content: undefined,
    size: 'small',
    name: '',
    open(name, id, action) {
        mithril_1.default.route.set(action ? (0, detail_link_1.getDetailLinks)(name, id, action) :
            (0, detail_link_1.getDetailLinks)(name, undefined, id));
    },
    linkTo(label, name, id, action) {
        return (0, mithril_1.default)("a", { href: `#${(0, detail_link_1.getDetailLinks)(name, id, action)}` }, label);
    },
    render() {
        let opts = mithril_1.default.route.param('opts');
        let details_opts = {};
        if (opts != "") {
            let arr = opts.split(/\&/);
            for (let i = 0; i < arr.length; i++) {
                let p = arr[i];
                let [name, value] = p.split(/\=/);
                details_opts[name] = value;
            }
        }
        return renderRightPanel(details_opts);
    },
    oncreate() {
        document.addEventListener("keydown", handleEscape);
    },
    onremove() {
        document.removeEventListener("keydown", handleEscape);
    },
    close() {
        closePanel();
    },
    view(vnode) {
        if (!this.opened)
            return;
        let klazz = ["right-panel", "container"];
        klazz.push(this.size);
        return [
            (0, mithril_1.default)("div", { class: ["right-panel-overlay", "open"].join(" ") }),
            (0, mithril_1.default)("div", { class: ["right-panel-container", "open", this.size].join(" "),
                onclick: (evt) => {
                    let target = evt.target;
                    if (target instanceof HTMLElement &&
                        target.classList.contains("right-panel-container")) {
                        closePanel();
                    }
                }
            }, (0, mithril_1.default)("div", { class: klazz.join(" ") }, (0, mithril_1.default)("a.close.right-panel-previous", { onclick: goBackHistory }, "<"), (0, mithril_1.default)("a.close.right-panel-close", { onclick: closePanel }, "×"), (0, mithril_1.default)("div", vnode.key), (0, mithril_1.default)("div", vnode.children)))
        ];
    }
};
